// extracted by mini-css-extract-plugin
export var header = "_tf-1";
export var maskBottom = "_tf-6";
export var maskMiddle = "_tf-7";
export var maskTop = "_tf-5";
export var root = "_tf-0";
export var scrollDownButton = "_tf-3";
export var scrollDownButtonHidden = "_tf-4";
export var viewport = "_tf-2";